import ChatMessage from "../../../model2/chat/chat-message/chat-message"
import {ChatType} from "../../../model2/chat/chat/const"
import ChatLocalSettings from "../../../../app/chat/chat/local-settings"
import Chat from "../../../model2/chat/chat/chat"
import ChatMessageCollection from "../../../model2/chat/chat-message/chat-messages"
import formatDateHumanize from "../../../gd/format/date-humanize"

export default class ChatManager {

    public dataManager         : any
    public chatId              : ID | null
    public localSettings       : ChatLocalSettings | null
    public chat                : Chat
    public messages            : ChatMessageCollection
    public starred             : ChatMessageCollection
    public toggleStarredAllowed: boolean                    = true
    public skin                : 'default' | 'discussion'   = 'default'

    constructor(chatId: ID | null, localSettings: ChatLocalSettings | null) {

        this.chatId                 = chatId
        this.chat                   = gd.session.chats?.get(this.chatId!)
        this.messages               = new ChatMessageCollection([], this.chatId!)
        this.starred                = new ChatMessageCollection([], this.chatId!)

        this.localSettings          = localSettings

        gd.bus.subscribe("chat-room:newMessage", this, this.onNewMessage)
    }

    __destroy() {
        gd.bus.unsubscribe(this)
    }

    setChatId = (id: ID) => {
        this.chatId = id
    }

    getStarred = () => {
        return this.starred ? this.starred : []
    }

    getChatInstanceLabel = () => {
        switch (this.chat?.systemType) {
            case ChatType.USER  :
            case ChatType.GROUP : return 'chat'
            default             : return 'discussion'
        }
    }

    addMessage(message: ChatMessage) {
        this.messages.add(message)
    }

    updateMessage(data: any) {
        let editedMessage = this.messages.get(data.id)
        _.assign(editedMessage, data)

        let editedStarred = this.starred.get(data.id)
        _.assign(editedStarred, data)
        gd.bus.triggerEvent('chat-room:starredUpdate')
    }

    deleteMessage(data: any) {
        this.messages.remove(data.id)
        this.starred.remove(data.id)
    }

    starMessage(messageId: ID, isStarred: boolean) {
        const message = this.messages.get(messageId)
        if (isStarred) {
            if (message && !this.starred.get(messageId)) this.starred.add(message)
        } else this.starred.remove(messageId)
        gd.bus.triggerEvent('chat-room:starredMessageUpdate', messageId, isStarred)
        gd.bus.triggerEvent('chat-room:starredUpdate')
    }

    editMessage = (message: ChatMessage) => {
        console.log("DEPRICATED NOT IN USE ???")
        gd.api.Chat.editChatMessage(this.chatId, message.id, message.message, message.messageRTF)
    }

    sendMessage = (message: ChatMessage, messageRTF: any, attachments: any) => {
        const newMessage = {
            chatId          : this.chatId,
            userId          : gd.user.id,
            momentCreated   : moment(),
            message         : message,
            messageRTF      : messageRTF,
            tempId          : gd.utils.guid()
        }
        gd.api.Chat.newChatMessage(this.chatId, message, messageRTF, attachments, newMessage.tempId)
    }

    getGroupedMessages() {
        return _.chain(this.messages.models)
            .orderBy(m=>m.momentCreated ? m.momentCreated.format("x") : moment().add(1,'day'))
            .groupBy(m=>formatDateHumanize(m.momentCreated ? m.momentCreated : moment(),"MMM D, dddd"))
            .toPairs()
            .map(g=>({
                day     : g[0],
                messages: g[1]
            }))
            .value()
    }

    //events handlers
    onNewMessage(message: ChatMessage) {
        if (this.chat && message.id === this.chat.id && message.metaData) {
            switch (message.metaData.type) {
                case 'left-chat'    :
                    this.chat.users = _.filter(this.chat.users, uId=>!message.metaData.users.includes(uId))
                    gd.bus.triggerEvent('chat-room:usersUpdate')
                    break

                case 'add-user'     :
                    if (this.chat.systemType === gd.const.chat.systemType.GROUP) {
                        this.chat.users = _.union(this.chat.users, message.metaData.users)
                    } else {
                        const newUsers: any[] = _.map(message.metaData.users, (id)=>({userId: id, role: gd.const.meeting.role.PARTICIPANT}))
                        this.chat.users = _.unionBy(this.chat.users, newUsers, (user: any)=>user.userId)
                    }

                    gd.bus.triggerEvent('chat-room:usersUpdate')
                    break

                case 'remove-user'  :
                    this.chat.users = _.filter(this.chat.users, uId=>!message.metaData.users.includes(uId))
                    gd.bus.triggerEvent('chat-room:usersUpdate')
                    break
            }
        }
    }
}